import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { BatchCallNameField } from './fields/BatchCallNameField';
import { FromNumberField } from './fields/FromNumberField';
import { RecurringCallField } from './fields/RecurringField';
import { UploadRecipientsField } from './fields/UploadRecipientsField';
import { WhenToSendField } from './fields/WhenToSendField';
import { FormActions } from './FormActions';

type Props = {
  onCancel: () => void;
  isSubmitting?: boolean;
};

export const BatchCallDetailsForm = ({ onCancel, isSubmitting }: Props) => {
  return (
    <Card className="bg-muted rounded-2xl p-1 pt-0 gap-0 border-0 shadow-none flex flex-col">
      <CardHeader className="flex flex-col px-5 py-3">
        <CardTitle className="text-sm">Batch Call Details</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3 bg-card p-6 rounded-xl shadow-sm flex-1">
        <div className="space-y-6">
          <BatchCallNameField />
          <FromNumberField />
          <UploadRecipientsField />
          <WhenToSendField />
          <RecurringCallField />
          <FormActions onCancel={onCancel} isSubmitting={isSubmitting} />
        </div>
      </CardContent>
    </Card>
  );
};
